
export default [
    //HomeRoute
    
    {
        path:'/basicHome',
        name:'basic-home',
        component: () => import('@/components/Basic/Home.vue'),
        meta: {
            layout: 'full',
        }
    },
    //Basic/Farm-Route
    {
        path:'/basicHome/Farm',
        name:'basic-farm',
        component: () => import('@/components/Basic/Farm/FarmList.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/Animals',
        name:'basic-animals',
        component: () => import('@/components/Basic/Farm/Animals.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/AnimalsStatus',
        name:'basic-animals-status',
        component: () => import('@/components/Basic/Farm/AnimalsStatus.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/AnimalsReproductive/:id/:type',
        name:'basic-animals-reproductive',
        component: () => import('@/components/Basic/Farm/Info/Reproductive.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/AnimalsChilds/:id',
        name:'basic-animals-childs',
        component: () => import('@/components/Basic/Farm/Info/Childs.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/Animals/Vaccines/:id',
        name:'animals-info-vaccines',
        component: () => import('@/components/Basic/Farm/Info/Vaccines.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/Animals/Dewormings/:id',
        name:'animals-info-dewormings',
        component: () => import('@/components/Basic/Farm/Info/Dewormings.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/Animals/Treathments/:id',
        name:'animals-info-treathments',
        component: () => import('@/components/Basic/Farm/Info/Treathments.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/basicHome/Animals/Alerts/:id',
        name:'animals-info-alerts',
        component: () => import('@/components/Basic/Farm/Info/Alerts.vue'),
        meta: {
            layout:'full',
        }
    },

    {
        path:'/basicHome/Users',
        name:'basic-users',
        component: () => import('@/components/Basic/Farm/UserList.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/basicHome/addUser',
        name:'basic-addusers',
        component: () => import('@/components/Basic/Farm/AddUser.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/cancel-account',
        name:'cancel-account',
        component: () => import('@/components/Basic/CancelAccount.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/basicHome/createUser',
        name:'basic-createuser',
        component: () => import('@/components/Basic/Farm/CreateUser.vue'),
        meta: {
            layout: 'full',
        }
    },



    {
        path:'/basicHome/Advice',
        name:'basic-advice',
        component: () => import('@/components/Basic/Farm/GetAdvice/GetAdvice.vue'),
        meta: {
            layout: 'full',
        }
    },
    //Reports
    {
        path:'/basicHome/Report',
        name:'basic-report',
        component: () => import('@/components/Basic/Report.vue'),
    },
    {
        path:'/basicHome/ReproductiveState',
        name:'reproductive-state-report',
        component: () => import('@/components/Basic/Reports/Reproductive.vue'),
    },
    {
        path:'/basicHome/HealthState',
        name:'health-state-report',
        component: () => import('@/components/Basic/Reports/Health.vue'),
    },
    {
        path:'/basicHome/Productive',
        name:'productive-report',
        component: () => import('@/components/Basic/Reports/Productive.vue'),
    },
    {
        path:'/basicHome/Inventory',
        name:'inventory-report',
        component: () => import('@/components/Basic/Reports/Animals.vue'),
    },
    {
        path:'/basicHome/Economic',
        name:'economic-report',
        component: () => import('@/components/Basic/Reports/Economic.vue'),
    },
    {
        path:'/alerts',
        name:'alerts',
        component: () => import('@/components/Basic/Reports/Alerts.vue'),
    },
    //End Reports

    {
        path:'/basicHome/AdviceList',
        name:'basic-advicelist',
        component: () => import('@/components/Basic/Farm/GetAdvice/Advice.vue'),
        meta: {
            layout: 'full',
        }
    },
    //Basic DataLog-Route
    {
        path:'/basicHome/datalog/',
        name:'basic-dataloghome',
        component: () => import('@/components/Basic/DataLog/Home.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/basicHome/datalog/farm',
        name:'basic-datalogfarm',
        component: () => import('@/components/Basic/DataLog/FarmList.vue'),
        meta: {
            layout: 'full',
        }
    },

    // {
    //     path:'/basicHome/datalog/animals',
    //     name:'basic-animals',
    //     component: () => import('@/components/Basic/DataLog/Animals.vue'),
    //     meta: {
    //         layout:'full',
    //     }
    // },
    
    //Basic DataLog-Economics-Route
    {
        path:'/basicHome/datalog/economics/home',
        name:'basic-economicshome',
        component: () => import('@/components/Basic/DataLog/Economics/Home.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/economics/product',
        name:'basic-economicsproduct',
        component: () => import('@/components/Basic/DataLog/Economics/Product.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/basicHome/datalog/economics/typeincome',
        name:'basic-economicstypeincome',
        component: () => import('@/components/Basic/DataLog/Economics/TypeIncome.vue'),
        meta: {
            layout: 'full',
        }
    },
    
    
    {
        path:'/basicHome/datalog/economics/expense',
        name:'basic-economicsexpense',
        component: () => import('@/components/Basic/DataLog/Economics/Expense.vue'),
        meta: {
            layout: 'full',
        }
    },


    {
        path:'/basicHome/datalog/economics/animal',
        name:'basic-economicsanimal',
        component: () => import('@/components/Basic/DataLog/Economics/Animal.vue'),
        meta: {
            layout: 'full',
        }
    },
    //Basic-Datalog-Animal-Route
    {
        path:'/basicHome/datalog/animal/home',
        name:'basic-animalhome',
        component: () => import('@/components/Basic/DataLog/Animal/Home.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/animal/switchAnimal',
        name:'basic-switchanimal',
        component: () => import('@/components/Basic/DataLog/Animal/SwitchAnimal.vue')
    },
    {
        path:'/basicHome/datalog/animal/addAnimal',
        name:'basic-animaladdanimal',
        component: () => import('@/components/Basic/DataLog/Animal/AddAnimal.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/basicHome/datalog/animal/addAnimalEn',
        name:'basic-animaladdanimalen',
        component: () => import('@/components/Basic/DataLog/Animal/AddAnimalEn.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/animal/animalCalendar',
        name:'basic-animalcalendar',
        component: () => import('@/components/Basic/DataLog/Animal/AnimalCalendar.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/animal/animalExit',
        name:'basic-animalexit',
        component: () => import('@/components/Basic/DataLog/Animal/AnimalExit.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/healthweight/home',
        name:'basic-healthweighthome',
        component: ()  => import('@/components/Basic/DataLog/HealthWeight/Home.vue'),
        meta: {
            layout: 'full',
        }
    },


    {
        path:'/basicHome/datalog/healthweight/health',
        name:'basic-healthweighthealth',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Health.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/vaccineIndex',
        name:'basic-healthvaccineIndex',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/VaccineIndex.vue'),
        meta: {
            layout: 'full'
        }
    },


    {
        path:'/basicHome/datalog/healthweight/health/vaccine',
        name:'basic-healthvaccine',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Vaccine.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/VaccineEdit/:id',
        name:'basic-vaccineEdit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/VaccineEdit.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/basicHome/datalog/healthweight/health/HealthIndex',
        name:'basic-HealthIndex',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/HealthIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/deworming',
        name:'basic-loaddatadeworming',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Deworming.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/dewormingedit/:id',
        name:'basic-dewormingEdit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/DewormingEdit.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/treatmentIndex',
        name:'basic-diseasetreatmentIndex',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/TreatmentIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/treatment',
        name:'basic-diseasetreatment',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Treatment.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/TreatmentEdit/:id',
        name:'basic-TreatmentEdit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/TreatmentEdit.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/exameneIndex',
        name:'basic-healthexameneIndex',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/ExameneIndex.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/basicHome/datalog/healthweight/health/ExameneEdit/:id',
        name:'basic-ExameneEdit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/ExameneEdit.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/basicHome/datalog/healthweight/health/examene',
        name:'basic-healthexamene',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Examene.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path: '/basicHome/datalog/healthWeight/health/alert',
        name: 'basic-healthalert',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Alert.vue')
    },

    {
        path: '/basicHome/datalog/healthWeight/reproduction/home',
        name: 'basic-healthreproductionhome',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Home.vue'),

    },

    {
        path: '/basicHome/datalog/healthWeight/reproduction/male',
        name: 'basic-healthreproductionmale',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Male/MaleIndex.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/femaleIndex',
        name: 'basic-femaleIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/FemaleIndex.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/PalpationIndex',
        name: 'basic-palpationIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/PalpationIndex.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/ServicesIndex',
        name: 'basic-servicesIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/ServicesIndex.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/female',
        name: 'basic-healthreproductionfemale',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/Female.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/femaleswitch',
        name: 'basic-femaleswitch',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/FemaleSwitchOptions.vue'),
    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/male/dataupload',
        name: 'basic-dataupload',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Male/DataUpload.vue'),

    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/male/datauploadEdit/:id',
        name: 'basic-datauploadedit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Male/DataUploadEdit.vue'),

    },
    {
        path: '/basicHome/datalog/healthWeight/reproduction/female/dataloaddelivery',
        name: 'basic-femaledataloaddelivery',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataloadDelivery.vue'),

    },

    {
        path:'/basicHome/datalog/healthWeight/reproduction/female/dataloadabort',
        name: 'basic-femaledataloadabort',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataloadAbort.vue'),
    },

    {
        path:'/basicHome/datalog/healthWeight/reproduction/female/datapalpations',
        name:'basic-femaledatapalpations',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataloadPalpations.vue')
    },

    {
        path:'/basicHome/datalog/healthWeight/reproduction/female/dataservices',
        name:'basic-femaledataservices',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataloadServices.vue')
    },

    {
        path:'/basicHome/datalog/healthWeight/reproduction/female/datainsemination',
        name:'basic-femaledatainsemination',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataloadInsemination.vue')
    },

    {
        path:'/basicHome/datalog/healthWeight/reproduction/female/datanaturalriding',
        name:'basic-femaledatanaturalriding',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Reproduction/Female/DataNaturalRiding.vue')
    },
    {
        path:'/basicHome/datalog/healthWeight/milk',
        name:'basic-healthmilkhome',
        component: () => import('@/components/Advance/DataLog/HealthWeight/MilkIndex.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/milkadd',
        name:'basic-healthmilkadd',
        component: () => import('@/components/Basic/DataLog/HealthWeight/MilkHome.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/drycows',
        name:'basic-healthdrycows',
        component: () => import('@/components/Advance/DataLog/HealthWeight/DryCowsIndex.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/drycowsadd',
        name:'basic-healthdrycowsadd',
        component: () => import('@/components/Basic/DataLog/HealthWeight/DryCows.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/milkProduction',
        name:'basic-healthmilkproduction',
        component: () => import('@/components/Basic/DataLog/HealthWeight/MilkProduction.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/livestockIndex',
        name:'basic-healthlivestockhome',
        component: () => import('@/components/Advance/DataLog/HealthWeight/LivestockIndex.vue'),
    },
    {
        path:'/basicHome/datalog/healthWeight/livestock',
        name:'basic-healthlivestockupload',
        component: () => import('@/components/Basic/DataLog/HealthWeight/LivestockUpload.vue'),
    },

    {
        path:'/basicHome/farm/createfarm',
        name:'basic-createFarm',
        component: () => import('@/components/Basic/DataLog/HealthWeight/CreateFarm.vue'),

    },

    {
        path:'/basicHome/farm/editfarm/:id',
        name:'basic-editFarm',
        component: () => import('@/components/Basic/DataLog/HealthWeight/EditFarm.vue'),

    },

    ///////////////URL
    {
        path:'/basicHome/economicstatus',
        name:'basic-economicStatus',
        component: () => import('@/components/Basic/EconomicStatus.vue'),
    },

    {
        path:'/basicHome/totalrevenue',
        name:'basic-totalrevenue',
        component: () => import('@/components/Basic/TotalRevenue.vue'),
    },
    {
        path:'/account-settings',
        name:'basic-profile',
        component: () => import('@/components/Basic/Profile.vue'),
    },

]